switch (process.env.ENV_TAREGT) {
    case 'dev_test':
        global.LoginPath = 'https://www.weixiaojia.net/wxcepClient1/';
        global.BasePath = 'https://api.weixiaojia.net/wxcepClient1/';
        global.newcharge = 'https://pay.weixiaojia.net/';
        global.wyms = 'https://wyms.weixiaojia.net/wyms/';
        global.command = 'dev_mock';
        break;
    case 'build_test':
        global.LoginPath = 'https://www.weixiaojia.net/wxcepClient1/';
        global.BasePath = 'https://api.weixiaojia.net/wxcepClient1/';
        global.newcharge = 'https://pay.weixiaojia.net/';
        global.wyms = 'https://wyms.weixiaojia.net/wyms/';
        global.command = 'build_test';
        break;
    case 'production':
        global.LoginPath = 'https://www.zhxiaoyuan.cn/wxcepClient1/';
        global.BasePath = 'https://www.zhxiaoyuan.cn/wxcepClient1/';
        global.newcharge = 'https://pay.zhxiaoyuan.cn/';
        global.wyms = 'https://wyms.weixiaojia.cn/wyms/';
        global.command = 'production';
        break;
}



// WEBPACK FOOTER //
// ./src/utils/initEnv.js